import React from "react";
import QuizStatus from "./quiz-status.jsx";
import Progress from "./progress.jsx";

/**
 * @typedef {object} FormHeaderProps
 * @property {boolean} showTitle whether to show the title
 * @property {string} title - title of the form
 * @property {boolean} isQuiz - whether this is a quiz or something else
 * @property {number} questionCount - number of questions
 * @property {number} pageCount - number of pages
 * @property {number} currentPageNumber - current page number
 */

/**
 * @param {FormHeaderProps} props - props
 * @returns {React.JSX.Element} FormHeader
 */
function FormHeader({
  showTitle,
  title,
  isQuiz,
  questionCount,
  pageCount,
  currentPageNumber,
}) {
  const percentage = Math.floor((currentPageNumber / pageCount) * 100);
  return (
    <div className="fr-mb-2">
      <div className="md:fr-flex">
        <div className="md:fr-w-1/2 md:fr-flex">
          {showTitle && (
            <h2 className="fr-font-medium fr-text-2xl fr-mb-2 fr-text-zinc-800 fr-mr-auto">
              {title}
            </h2>
          )}
        </div>
        <div className="fr-p-2 md:fr-w-1/2 md:fr-text-right">
          {pageCount > 1 && <span>{percentage}% Complete</span>}
          {isQuiz && <QuizStatus questionCount={questionCount} />}
        </div>
      </div>
      <div>
        {pageCount > 1 && (
          <Progress
            maxValue={100}
            currentValue={percentage === 0 ? 0 : percentage}
          />
        )}
      </div>
    </div>
  );
}

export default FormHeader;
